"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tutorials__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "ca509669-b854-409f-a9dd-949c9ed538be",
    "data-name": "Tutorials_ic_hi",
    viewBox: "0 0 192 191.5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "9ea92290-4342-4bc8-8633-cfc347ff1343",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 135.87,
    x2: 96,
    y2: 79.89,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "101d8356-3c9d-40b6-8aad-00bd45f42ffb",
    "data-name": "<Pfad>",
    x1: 85.75,
    y1: 135.92,
    x2: 106.25,
    y2: 135.92,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "c6277f27-4b98-42d5-9866-3cb8d46b302f",
    "data-name": "<Pfad>",
    x1: 84.42,
    y1: 79.88,
    x2: 96,
    y2: 79.88,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f314245e-0afe-45d1-985f-d99cd0a095f9",
    "data-name": "<Pfad>",
    cx: 93.8,
    cy: 60.5,
    r: 6,
    fill: "#e60000"
  }))), /*#__PURE__*/React.createElement("title", null, "tutorials-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "1ef7e043-7c0e-4ba3-90da-608de1bdbb09",
    "data-name": "Tutorials_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "e13cd2a3-8d9c-4fbe-bce6-7575530af7e3",
    "data-name": "Tutorials_ic_hi",
    width: 192,
    height: 191.5,
    transform: "translate(0 0.12)",
    xlinkHref: "#ca509669-b854-409f-a9dd-949c9ed538be"
  })));
}

var _default = ic_tutorials__dark;
exports.default = _default;